
import Ajax from '../js/common/ajax';
/**
 *	结算相关接口
 */
export default {
	list() {
		return Ajax.get("/checkout")
	},
	initialCheck(params) {
		return Ajax.get("/checkout/initialCheck", params)
	},
	finalCheck(params) {
		return Ajax.get("/checkout/finalCheck", params)
	},
	reportCheck(params) {
		return Ajax.get("/checkout/reportCheck", params)
	},
	brokenCheck(params) {
		return Ajax.get("/checkout/brokenCheck", params)
	},
	invoicing(params) {
		return Ajax.get("/checkout/invoicing", params)
	},
	unCheck(params) {
		return Ajax.get("/checkout/unCheck", params)
	}
}